import { FC } from 'react'
import { useTranslate } from 'react-admin'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { themeColor } from '../../../layout/theme/color'
import { LoopNodeData, WorkflowNodeData } from '../types'
import ExpressionTextField from '../autocomplete/ExpressionTextField'

interface LoopConfigProps {
  data: LoopNodeData
  onUpdate: (data: Partial<WorkflowNodeData>) => void
}

const LoopConfig: FC<LoopConfigProps> = ({ data, onUpdate }) => {
  const translate = useTranslate()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label={translate('workflow.config.label')}
        value={data.label}
        onChange={(e) => onUpdate({ label: e.target.value })}
        size="small"
        fullWidth
      />
      <ExpressionTextField
        label={translate('workflow.config.arrayExpression')}
        value={data.arrayExpression}
        onChange={(e) => onUpdate({ arrayExpression: e.target.value })}
        size="small"
        fullWidth
        placeholder="nodes.get_notifications.output.results"
      />
      <TextField
        label={translate('workflow.config.itemVariable')}
        value={data.itemVariable}
        onChange={(e) => onUpdate({ itemVariable: e.target.value })}
        size="small"
        fullWidth
        placeholder="item"
      />
      <Box>
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(data.logChildren)}
              onChange={(e) => onUpdate({ logChildren: e.target.checked })}
              size="small"
            />
          }
          label={translate('workflow.config.loopLogChildren')}
        />
        <Typography
          variant="caption"
          sx={{ color: themeColor.slate60, mt: 0.5, display: 'block', lineHeight: 1.4 }}
        >
          {translate('workflow.config.loopLogChildrenHelp')}
        </Typography>
      </Box>
    </Box>
  )
}

export default LoopConfig
